import { useTranslation } from '../../../lib/i18n';
import { useOpenSideChat } from '../../../lib/use-open-side-chat';
import { ATTENTION_KEYS, presenceChatContext, type PresenceChat, type PresenceLink } from '../../../lib/presence';
import { websiteChatContext } from '../../../lib/workspace-website';

/** Opens the Space's chat for a presence action: the seed and the hidden context the action carries. */
export function usePresenceChat(workspaceId: string, workspaceName: string) {
  const { t } = useTranslation();
  const openSideChat = useOpenSideChat();
  return (chat: PresenceChat) => {
    const message = 'text' in chat ? chat.text : t(chat.message.key, chat.message.values);
    const context =
      chat.context.kind === 'website'
        ? websiteChatContext(workspaceId, workspaceName, chat.context.website)
        : presenceChatContext(workspaceId, workspaceName, chat.context.resource, chat.context.intent);
    openSideChat({ kind: 'new', message, context, workspaceId });
  };
}

/** The accessible name of a presence mark: "{name} on {provider}", plus its attention ("…, Login expired"). */
export function usePresenceLabel() {
  const { t } = useTranslation();
  return (link: Pick<PresenceLink, 'name' | 'providerName' | 'attention'>) => {
    const base = link.providerName ? t('workspace.presence.linkLabel', { name: link.name, provider: link.providerName }) : link.name;
    return link.attention ? t('workspace.presence.linkLabelAttention', { name: base, state: t(ATTENTION_KEYS[link.attention]) }) : base;
  };
}

